// Fluent Emoji Flat graduation cap (MIT), with the near-black purples
// lightened to Make purple so the cap stays visible on the dark-mode tile.
export const GraduationCapIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={35}
    height={35}
    viewBox="0 0 32 32"
    role="img"
    aria-label="Developer Onboarding"
  >
    <path
      fill="#6D5BD0"
      d="M19.3 23.138h-6.64c-3.84 0-6.95-3.11-6.95-6.95v-4.36h20.53v4.36c.01 3.84-3.1 6.95-6.94 6.95"
    />
    <path
      fill="#9A8CF0"
      d="m17.13 5.278l12.28 6.29c.76.39.76 1.48 0 1.87l-12.28 6.29c-.72.37-1.56.37-2.28 0l-12.28-6.29c-.76-.39-.76-1.48 0-1.87l12.28-6.29a2.48 2.48 0 0 1 2.28 0"
    />
    <path
      fill="#FFB02E"
      d="M15.15 12.048c.19-.41.68-.57 1.08-.37l6.71 3.44c.27.14.43.41.43.71v6.28a1.83 1.83 0 0 1 .97 2.1v.02c-.01.04-.02.09-.04.13c0 .01-.01.02-.01.03c-.01.04-.03.08-.05.12c0 .01-.01.02-.01.02c-.05.11-.12.22-.19.31c-.01.02-.02.03-.04.05l.47 2.2a1.94 1.94 0 0 1-1.9 2.35a1.94 1.94 0 0 1-1.9-2.35l.47-2.2c-.25-.31-.4-.7-.4-1.13c0-.25.05-.49.14-.7c0-.01.01-.02.02-.03c.01-.03.03-.07.05-.1c.02-.04.04-.08.07-.12c.01-.01.01-.02.02-.03c.18-.28.44-.51.74-.66v-5.8l-6.25-3.2c-.39-.2-.57-.68-.38-1.07"
    />
  </svg>
);
